module.exports = __webpack_public_path__ + "0af5d249/img/copy-icon.408fdb2d.svg";